import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const MastercardIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_148964)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="#1A1A1A"
        />
        <path d="M18.5362 20.0905H13.9648V11.9141H18.5362V20.0905Z" fill="#FF5F00" />
        <path
          d="M14.2577 16.0008C14.2577 14.3422 15.038 12.8647 16.2531 11.9126C15.3645 11.2163 14.243 10.8008 13.0243 10.8008C10.1389 10.8008 7.80005 13.1289 7.80005 16.0008C7.80005 18.8727 10.1389 21.2008 13.0243 21.2008C14.243 21.2008 15.3645 20.7852 16.2531 20.089C15.038 19.1369 14.2577 17.6594 14.2577 16.0008Z"
          fill="#EB001B"
        />
        <path
          d="M24.7014 16.0008C24.7014 18.8727 22.3625 21.2008 19.4772 21.2008C18.2584 21.2008 17.137 20.7852 16.248 20.089C17.4635 19.1369 18.2438 17.6594 18.2438 16.0008C18.2438 14.3422 17.4635 12.8647 16.248 11.9126C17.137 11.2163 18.2584 10.8008 19.4772 10.8008C22.3625 10.8008 24.7014 13.1289 24.7014 16.0008Z"
          fill="#F79E1B"
        />
      </g>

      <defs>
        <clipPath id="clip0_2177_148964">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
